import type { MealCondition, MealMetric } from "@/lib/schema";
import { densityVerdicts } from "./density";
import { conditionLabel } from "./metrics";

export function MetricCellDensity({
  conditions,
  metric,
  amounts,
  testidFor,
}: {
  conditions: MealCondition[];
  metric: MealMetric;
  amounts: Record<MealMetric, number>;
  testidFor: (conditionId: string) => string;
}) {
  const verdicts = densityVerdicts(conditions, metric, amounts);
  if (verdicts.length === 0) return null;
  return (
    <span className="density-indicators">
      {verdicts.map(({ condition, verdict, deviationPercent }) => {
        const quality =
          verdict === "good"
            ? "bra tetthet"
            : condition.direction === "atLeast"
              ? "for lav tetthet"
              : "for høy tetthet";
        const percentText = `${deviationPercent > 0 ? "+" : ""}${deviationPercent} %`;
        return (
          <span
            key={condition.id}
            className={`density-indicator ${verdict}`}
            title={`${conditionLabel(condition)} – ${quality} per kcal`}
            data-testid={testidFor(condition.id)}
          >
            ({percentText})
          </span>
        );
      })}
    </span>
  );
}
